import { render, staticRenderFns } from "./DispensedPatientIndexComponent.vue?vue&type=template&id=584ac26c"
import script from "./DispensedPatientIndexComponent.vue?vue&type=script&lang=js"
export * from "./DispensedPatientIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports